import {registerCustomComponents} from "../components/RegisterComponents";
import {bindEmbedElement} from "./BindEmbed";
import {createScreenManagerBindings, showPrimaryScreen} from "../screens/ScreenManager";
import {preload} from "../preloader/Preload";
import {createGameManager, getGameManager} from "../game/GameManager";
import {loadMusic} from '../game/audio/AudioManager';

/**
 * bootstrap the app
 */
export function bootstrapApp()
{
    //  set height of container element

    setContainerHeight();

    //  create a new instance of the game manager class;
    //  this will handle interactions and communication between the app and the game

    createGameManager();

    //  create screen manager bindings

    createScreenManagerBindings();
    
    //  register KO components

    registerCustomComponents();

    //  apply bindings to the embed element

    bindEmbedElement();

    //  start playing the looping music

    loadMusic();

    //  preload data

    preload()
        .then(() =>
        {
            getGameManager().createGame();
        });
}


function setContainerHeight()
{
    window.addEventListener('resize', () =>
    {
        document.getElementById('edf-power-patrol-embed').style.height = window.innerHeight + 'px';
    })
}



//function getIOSWindowHeight()
//{
//    // Get zoom level of mobile Safari
//    // Note, that such zoom detection might not work correctly in other browsers
//    // We use width, instead of height, because there are no vertical toolbars :)
//
//    var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
//
//    // window.innerHeight returns height of the visible area.
//    // We multiply it by zoom and get out real height.
//
//    return window.innerHeight * zoomLevel;
//};
//
//// You can also get height of the toolbars that are currently displayed
//
//function getHeightOfIOSToolbars()
//{
//    var tH = (window.orientation === 0 ? screen.height : screen.width) -  getIOSWindowHeight();
//    return tH > 1 ? tH : 0;
//}


// WEBPACK FOOTER //
// ./src/ts/embed/BootstrapApp.ts